import React from 'react';

import cs from 'classnames';

import { groupAndSort, snakeToTitleCase } from 'lib/helpers/utility';

import PopoverOption from '../Option/PopoverOption';

const PopoverOptions = ({
  options,
  level = 1,
  handleClose,
  parentPath = '',
  optionsGroupBy,
  optionGroupLabelClassName,
  separatorClassName,
  hoveredIndexes,
  handleMouseEnter,
  handleMouseLeave,
  handleOptionClick,
  activeOptionRef,
  submenuRefs,
  text,
  customButton,
  optionIconSize,
  optionIconColor,
  iconsShade,
  optionArrowIcon,
  optionArrowIconStroke,
  optionActiveIcon,
  optionArrowColor,
  position,
  renderOptions,
  optionIconNoColor
}) => {
  if (level === 1 && optionsGroupBy) {
    const groupedOptions = groupAndSort(options, optionsGroupBy);
    return groupedOptions.map(([groupName, groupOptions], groupIndex) => (
      <div className="flex flex-col" key={groupIndex}>
        <span
          className={cs(
            'mb-1 px-4 py-1 text-xs font-600 leading-[14px] text-neutral-900',
            optionGroupLabelClassName
          )}>
          {snakeToTitleCase(groupName)}
        </span>
        <div className="flex flex-col gap-1">
          {groupOptions.map((option, index) => (
            <PopoverOption
              key={index}
              option={option}
              index={index}
              level={level}
              handleClose={handleClose}
              parentPath={parentPath}
              hoveredIndexes={hoveredIndexes}
              handleMouseEnter={handleMouseEnter}
              handleMouseLeave={handleMouseLeave}
              handleOptionClick={handleOptionClick}
              activeOptionRef={activeOptionRef}
              submenuRefs={submenuRefs}
              text={text}
              customButton={customButton}
              optionIconSize={optionIconSize}
              optionIconColor={optionIconColor}
              iconsShade={iconsShade}
              optionArrowIcon={optionArrowIcon}
              optionArrowIconStroke={optionArrowIconStroke}
              optionActiveIcon={optionActiveIcon}
              optionArrowColor={optionArrowColor}
              position={position}
              renderOptions={renderOptions}
              separatorClassName={separatorClassName}
              optionIconNoColor={optionIconNoColor}
            />
          ))}
        </div>
      </div>
    ));
  }

  return options.map((option, index) => (
    <PopoverOption
      key={index}
      option={option}
      index={index}
      level={level}
      handleClose={handleClose}
      parentPath={parentPath}
      hoveredIndexes={hoveredIndexes}
      handleMouseEnter={handleMouseEnter}
      handleMouseLeave={handleMouseLeave}
      handleOptionClick={handleOptionClick}
      activeOptionRef={activeOptionRef}
      submenuRefs={submenuRefs}
      text={text}
      customButton={customButton}
      optionIconSize={optionIconSize}
      optionIconColor={optionIconColor}
      iconsShade={iconsShade}
      optionArrowIcon={optionArrowIcon}
      optionArrowIconStroke={optionArrowIconStroke}
      optionActiveIcon={optionActiveIcon}
      position={position}
      renderOptions={renderOptions}
      separatorClassName={separatorClassName}
      optionIconNoColor={optionIconNoColor}
    />
  ));
};

export default PopoverOptions;
